import { ReviewRepository } from "../../repositories/ReviewRepository";
import { ReviewRequestEntity } from "../../entities/ReviewEntity";

/**
 * Check Approved Review Use Case
 * Checks if entity has an approved review
 */
export class CheckApprovedReviewUseCase {
  constructor(private repository: ReviewRepository) {}

  async execute(params: {
    user_id: number;
    entity_type: string;
    entity_id: number;
    action_code: string;
  }): Promise<ReviewRequestEntity | null> {
    if (!params.user_id || params.user_id <= 0) {
      throw new Error("Invalid user ID");
    }

    if (!params.entity_type || params.entity_type.trim() === "") {
      throw new Error("Entity type is required");
    }

    if (!params.entity_id || params.entity_id <= 0) {
      throw new Error("Invalid entity ID");
    }

    if (!params.action_code || params.action_code.trim() === "") {
      throw new Error("Action code is required");
    }

    return await this.repository.checkApprovedReview(params);
  }
}
